import axios from "axios";
import { auth } from "../services/firebase";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Automatically add fresh token to all requests
apiClient.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401/403 responses and subscription expired globally
apiClient.interceptors.response.use(
  (response) => {
    if (response.data?.status === 'expired') {
      if (window.location.pathname !== '/subscription-expired') {
        window.location.href = "/subscription-expired";
        return Promise.reject(new Error('Subscription expired'));
      }
    }
    return response;
  },
  async (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Token expired or invalid - sign out and redirect
      await auth.signOut();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;